import React, { useState } from 'react';
import { getClosingTime } from './vendor';

function VendorMoreInfoModal({ vendor, vendorType = 'vendor', onClose }) {
  const [showCopiedNotification, setShowCopiedNotification] = useState(false);
  // A generic fallback vector banner
  const defaultBanner = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 140'%3E%3Crect width='400' height='140' fill='%23f4f4f4'/%3E%3Cpath d='M-20 160 L100 40 L200 120 L300 60 L420 160 Z' fill='%23eaeaea'/%3E%3Ccircle cx='80' cy='60' r='16' fill='%23eaeaea'/%3E%3C/svg%3E`;
  
  const bannerStyle = { 
    width: '100%', 
    height: '140px', 
    backgroundImage: `url('${vendor.bannerUrl || vendor.imageUrl || defaultBanner}')`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center', 
    position: 'relative' 
  };

  const handleShare = () => {
    const urlToCopy = window.location.href;
    navigator.clipboard.writeText(urlToCopy).then(() => {
      setShowCopiedNotification(true);
      setTimeout(() => {
        setShowCopiedNotification(false);
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  return (
    <div className="vendors-modal-overlay">
      <div className="vendors-modal">
        <div style={bannerStyle}>
          <button className="vendors-close-btn" onClick={onClose} style={{ position: 'absolute', top: '16px', right: '16px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>×</button>
        </div>
        <div className="vendors-modal-body" style={{ padding: '0', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '24px 24px 16px 24px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: '700', margin: 0, color: '#111' }}>{vendor.name}</h2>
            {vendor.description && <p style={{ fontSize: '15px', color: '#888', margin: '8px 0 0 0', lineHeight: '1.4' }}>{vendor.description}</p>}
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #eaeaea', display: 'flex', alignItems: 'center', gap: '16px' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: '#888'}}><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              <span style={{ fontSize: '15px', color: '#111', fontWeight: '500' }}>Today open until {getClosingTime(vendor.workingHours)}</span>
            </div>

            <div style={{ padding: '16px 24px', borderTop: '1px solid #eaeaea', display: 'flex', alignItems: 'center', gap: '16px' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: '#111'}}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
              <span style={{ fontSize: '15px', color: '#111', fontWeight: '500' }}>{vendor.rating ? `${vendor.rating.toFixed(1)} (${vendor.reviewsCount || 0}+ ratings)` : 'No ratings yet'}</span>
            </div>

            <div className="vendor-modal-share-btn" onClick={handleShare}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: '#888'}}><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
              <span style={{ fontSize: '15px', color: '#111', fontWeight: '500' }}>Share this {vendorType}</span>
            </div>

            <div style={{ padding: '16px 24px', borderTop: '1px solid #eaeaea', borderBottom: '1px solid #eaeaea', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: '#888', marginTop: '2px', flexShrink: 0}}><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', paddingRight: '16px' }}>
                  <span style={{ fontSize: '15px', color: '#111', fontWeight: '500' }}>Hide vendor</span>
                  <span style={{ fontSize: '13px', color: '#888', lineHeight: '1.4' }}>We will hide this {vendorType} from you. This {vendorType} won't be shown to you anymore until you unhide it.</span>
                </div>
              </div>
              <input type="checkbox" style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#111', flexShrink: 0 }} />
            </div>
          </div>
          <div style={{ paddingBottom: '24px' }}></div>
        </div>
      </div>
      {showCopiedNotification && (
        <div className="copy-notification">
          Link copied
        </div>
      )}
    </div>
  );
}

export default VendorMoreInfoModal;